import {
  MaterialStartingBalanceStateTypes,
  MaterialStartingBalanceActionTypes,
} from "./MaterialStartingBalance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialStartingBalanceStateTypes = {
  fetchAll: resetApiCallState([]),
  bulkUpsert: resetApiCallState({}),
};

const MaterialStartingBalanceReducer = (
  state: MaterialStartingBalanceStateTypes = INITIAL_STATE,
  action: any
): MaterialStartingBalanceStateTypes => {
  switch (action.type) {
    case MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialStartingBalanceActionTypes.FETCH_ALL_MATERIAL_STARTING_BALANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------------------

    case MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE_RESET:
      return {
        ...state,
        bulkUpsert: resetApiCallState({}),
      };
    case MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE_FAILURE:
      return {
        ...state,
        bulkUpsert: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialStartingBalanceActionTypes.BULK_UPSERT_MATERIAL_STARTING_BALANCE_SUCCESS:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialStartingBalanceReducer;
